import { Handle, Position } from '@xyflow/react';
import { WorkflowHandlerID } from '../../workflow/ui';
import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { SOURCE_HANDLE_CLASSNAME, TARGET_HANDLE_CLASSNAME } from './helpers';

export const WatchJobNode = (props: TNodeProps) => {
  return (
    <BaseNode {...props} className="min-w-80">
      <Handle
        type="source"
        position={Position.Right}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_RIGHT}
      />
      <Handle
        type="target"
        position={Position.Left}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_LEFT}
      />
      <Handle
        type="source"
        position={Position.Top}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_TOP}
        style={{ left: '54%' }}
      />
      <Handle
        type="target"
        position={Position.Top}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_TOP}
        style={{ left: '46%' }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_BOTTOM}
        style={{ left: '54%' }}
      />
      <Handle
        type="target"
        position={Position.Bottom}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_BOTTOM}
        style={{ left: '46%' }}
      />
    </BaseNode>
  );
};
